import styled from 'styled-components';

export const Text = styled.p`
  margin-top: 0;
  margin-bottom: 16px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin: auto -8px;

  button {
    margin: 8px;
  }
`;
